import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountAdmin } from '@eightcap/core';
import { AccountService } from './account.service';
import { omit } from 'lodash';

@Injectable()
export class AccountAdminService extends AccountService {
    constructor(protected override httpClient: HttpClient) {
        super(httpClient);
    }

    override create(model: AccountAdmin): Observable<{ data: string }> {
        return this.httpClient
            .post(`${this.apiBasePath}/register_admin`, {
                data: omit(model, ['id'])
            })
            .pipe(
                map((response: { data: any }) => {
                    return {
                        data: response?.data?.account_number
                    };
                })
            );
    }
}
